export const authenticationService = {
  baseURL: 'https://testing.auth.cerclex.com',
};

